// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "21ec5ac103bfa5ef2a5821d3137ff0d3" + ".js";
};